import * as React from "react";
import Accordion from "web-ui/components/internal/Accordion";

import styles from "./AccordionPanel.module.scss";

interface Props {
  children?: React.ReactNode;
  header?: React.ReactNode;
}

const AccordionPanel = ({ children, header }: Props) => (
  <div className={styles.panel}>
    <Accordion
      bordered={false}
      inset={false}
      items={[{ content: children, defaultExpanded: true, header }]}
      textStyle="uppercase"
    />
  </div>
);

export default AccordionPanel;
